import { mdiCheckCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import { routes } from "constants/routes";
import styles from "./style.module.scss";

interface IProps {
  type: string;
}

export default function ConnectSuccess({ type }: Readonly<IProps>) {
  const navigate = useNavigate();

  function goBack() {
    navigate(
      type === "invited_profile"
        ? routes.HAULPAY_BROKER_INVITED_CARRIER
        : routes.HAULPAY_BROKER_CARRIERS_NEW
    );
  }

  return (
    <form className={styles.connectSuccessContainer}>
      <div className={styles.body}>
        <div className={styles.title}>
          <Icon path={mdiCheckCircleOutline} />
          <h3 className="text-xl font-medium">
            {type === "invited_profile" ? "Payment Profile Created" : "Connection Successful"}
          </h3>
        </div>
        <span>
          You’re now connected with this carrier. You should now be able to view the carrier and
          connection in the “My Carriers” section.
        </span>
      </div>

      <Button
        rounded
        size="lg"
        onClick={goBack}
        className="mobile:mx-auto desktop:!rounded-base desktop:!w-48 mt-auto desktop:ml-auto w-full">
        OK
      </Button>
    </form>
  );
}
